const Hospital = (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 22L2 22"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17 22V6C17 4.11438 17 3.17157 16.4142 2.58579C15.8284 2 14.8856 2 13 2H11C9.11438 2 8.17157 2 7.58579 2.58579C7 3.17157 7 4.11438 7 6V22"
      stroke="#183b56"
      strokeWidth="1.5"
    />
    <path
      d="M12 22V19"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10 12H14"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.5 11H7"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.5 14H7"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17 11H18.5"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17 14H18.5"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.5 8H7"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17 8H18.5"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 9V5"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 7L10 7"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.25 8.5C20.25 8.91421 20.5858 9.25 21 9.25C21.4142 9.25 21.75 8.91421 21.75 8.5H20.25ZM20.1111 5.33706L19.6945 5.96066L19.6945 5.96066L20.1111 5.33706ZM20.6629 5.88886L20.0393 6.30554L20.0393 6.30554L20.6629 5.88886ZM21.75 12.5C21.75 12.0858 21.4142 11.75 21 11.75C20.5858 11.75 20.25 12.0858 20.25 12.5H21.75ZM17.5 5.75C18.2178 5.75 18.6998 5.75091 19.0672 5.78828C19.422 5.82438 19.586 5.8882 19.6945 5.96066L20.5278 4.71346C20.1318 4.44886 19.6925 4.34415 19.219 4.29598C18.758 4.24909 18.1866 4.25 17.5 4.25V5.75ZM21.75 8.5C21.75 7.81338 21.7509 7.24196 21.704 6.78102C21.6559 6.30755 21.5511 5.86818 21.2865 5.47218L20.0393 6.30554C20.1118 6.41399 20.1756 6.57796 20.2117 6.93283C20.2491 7.30023 20.25 7.78216 20.25 8.5H21.75ZM19.6945 5.96066C19.831 6.05186 19.9481 6.16905 20.0393 6.30554L21.2865 5.47218C21.0859 5.17191 20.8281 4.91409 20.5278 4.71346L19.6945 5.96066ZM20.25 12.5V22H21.75V12.5H20.25Z"
      fill="#183b56"
    />
    <path
      d="M3.88886 5.33706L4.30554 5.96066L4.30554 5.96066L3.88886 5.33706ZM3.33706 5.88886L3.96066 6.30554L3.96066 6.30554L3.33706 5.88886ZM3.75 17C3.75 16.5858 3.41421 16.25 3 16.25C2.58579 16.25 2.25 16.5858 2.25 17H3.75ZM2.25 13C2.25 13.4142 2.58579 13.75 3 13.75C3.41421 13.75 3.75 13.4142 3.75 13H2.25ZM6.5 4.25C5.81338 4.25 5.24196 4.24909 4.78102 4.29598C4.30755 4.34415 3.86818 4.44886 3.47218 4.71346L4.30554 5.96066C4.41399 5.8882 4.57796 5.82438 4.93283 5.78828C5.30023 5.75091 5.78216 5.75 6.5 5.75V4.25ZM3.75 8.5C3.75 7.78216 3.75091 7.30023 3.78828 6.93283C3.82438 6.57796 3.8882 6.41399 3.96066 6.30554L2.71346 5.47218C2.44886 5.86818 2.34415 6.30755 2.29598 6.78102C2.24909 7.24196 2.25 7.81338 2.25 8.5H3.75ZM3.47218 4.71346C3.17191 4.91409 2.91409 5.17191 2.71346 5.47218L3.96066 6.30554C4.05186 6.16905 4.16905 6.05186 4.30554 5.96066L3.47218 4.71346ZM2.25 17V22H3.75V17H2.25ZM2.25 8.5V13H3.75V8.5H2.25Z"
      fill="#183b56"
    />
    <path
      d="M10 15H10.5M14 15H12.5"
      stroke="#183b56"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default Hospital;
